module.exports = __webpack_public_path__ + "img/Logo-dark.f34dcdc2.svg";